// extracted by mini-css-extract-plugin
export default {"panel":"panel§PcokFpu1l6QrMJxWxHjj","triangle":"triangle§UMDeQuO9F_WSuw0u2VFp","mainPanel":"mainPanel§ujdszP92zeyP02b7zpq0"};